import { Link } from "react-router-dom";
import { Phone, MapPin, ArrowUpRight } from "lucide-react";
import { PHONE, PHONE_DISPLAY, LOGO_URL, OFFICES, mapsUrl } from "../data/constants";
import { useContactDialogs } from "./ContactDialogs";

export default function Footer() {
  const { openBooking, openCallback } = useContactDialogs();

  return (
    <footer data-testid="footer" className="bg-foreground text-background">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <img src={LOGO_URL} alt="A/Z logó" className="h-12 w-12 object-contain bg-background p-1" />
              <span className="font-serif-display text-xl">Pénzügyi Megoldások</span>
            </div>
            <p className="text-background/60 max-w-sm leading-relaxed text-sm">
              Független pénzügyi tanácsadás Szabolcs-Szatmár-Bereg megyében és országosan.
              Hitel, munkáshitel, biztosítás és otthonteremtési megoldások — egy helyen, átláthatóan.
            </p>
            <a href={`tel:${PHONE}`} data-testid="footer-call-link"
              className="inline-flex items-center gap-3 mt-8 font-serif-display text-2xl hover:opacity-70 transition-opacity">
              <Phone className="h-5 w-5" /> {PHONE_DISPLAY}
            </a>
          </div>

          <div className="lg:col-span-4">
            <span className="overline text-background/50">Irodáink</span>
            <ul className="mt-6 space-y-4">
              {OFFICES.map((o) => (
                <li key={o.id}>
                  <a href={mapsUrl(o.query)} target="_blank" rel="noopener noreferrer"
                    data-testid={`footer-office-${o.id}`}
                    className="group flex items-start gap-3 text-sm text-background/70 hover:text-background transition-colors">
                    <MapPin className="h-4 w-4 mt-0.5 shrink-0" />
                    <span>
                      <span className="block text-background">{o.city}</span>
                      {o.address}
                    </span>
                    <ArrowUpRight className="h-4 w-4 ml-auto opacity-0 group-hover:opacity-100 transition-opacity" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <span className="overline text-background/50">Menü</span>
            <ul className="mt-6 space-y-3 text-sm">
              <li><Link to="/" className="text-background/70 hover:text-background transition-colors">Főoldal</Link></li>
              <li><Link to="/bemutatkozas" className="text-background/70 hover:text-background transition-colors">Bemutatkozás</Link></li>
              <li><Link to="/aszf" data-testid="footer-aszf-link" className="text-background/70 hover:text-background transition-colors">ÁSZF</Link></li>
              <li><button onClick={openBooking} className="text-background/70 hover:text-background transition-colors">Időpontfoglalás</button></li>
              <li><button onClick={openCallback} className="text-background/70 hover:text-background transition-colors">Visszahívás</button></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-background/15 flex flex-col sm:flex-row justify-between gap-4 text-xs text-background/50">
          <span>© {new Date().getFullYear()} Pénzügyi Megoldások. Minden jog fenntartva.</span>
          <Link to="/aszf" className="hover:text-background transition-colors">Általános Szerződési Feltételek</Link>
        </div>
      </div>
    </footer>
  );
}
